export const useProcessData = () => {
  return {
    labels: [],
    datasets: [
      {
        label: "",
        data: [],
        backgroundColor: [],
        borderColor: "#D5D5D5",
        borderWidth: 0,
        borderSkipped: false,
        borderRadius: 5,
        barPercentage: 0.6,
        categoryPercentage: 0.8,
        unit: ''
      }
    ]
  };
};

export const useProcessOption = () => {
  return {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: 'y',
    interaction: {
      intersect: false,
      mode: 'y'
    },
    scales: {
      x: {
        grid: { display: false },
        border: { display: false },
        ticks: { display: false }
      },
      y: {
        beginAtZero: true,
        grid: { display: false },
        border: { display: false },
        ticks: { display: false }
      },
    },
    plugins: {
      legend: { display: false },
      tooltip: {
        intersect: false,
        borderWidth: 1,
        borderColor: function (tooltip) {
          const item = tooltip.dataPoints?.[0];
          if (!item || !item.dataset) return '#9999CC';
          const noticeAry = item.dataset.note || [];
          return noticeAry.includes(item.label) ? '#ee99a8' : '#9999CC';
        },
        backgroundColor: function (tooltip) {
          const item = tooltip.dataPoints?.[0];
          if (!item || !item.dataset) return 'rgba(56, 56, 56, 0.8)';
          const noticeAry = item.dataset.note || [];
          return noticeAry.includes(item.label) ? 'rgba(238, 155, 170, 0.8)' : 'rgba(56, 56, 56, 0.8)';
        },
        caretSize: 10,
        titleAlign: 'center',
        titleColor: '#FAFAFB',
        titleMarginBottom: 5,
        bodySpacing: 5,
        bodyColor: '#FAFAFB',
        titleFont: { size: 14, weight: 'bold' },
        bodyFont: { size: 14, weight: 'bold' },
        padding: 10,
        displayColors: false,
        boxWidth: 10,
        boxHeight: 10,
        boxPadding: 5,
        filter: tooltipItem => {
          return tooltipItem.raw !== null && tooltipItem.dataset.note && tooltipItem.dataset.note.length > 0;
        },
        callbacks: {
          title: function (tooltipItems) {
            // const item = tooltipItems?.[0];
            // if (!item || !item.dataset || item.dataset.note.length > 0) return '';
            // return item.dataset.unit === 'server' ? '' : item.label;
            return null
          },
          label: function (tooltipItem) {
            if (!tooltipItem || !tooltipItem.dataset) return null;
            if (tooltipItem.raw === null) return null;
            if (tooltipItem.dataset.unit === 'server') {
              return tooltipItem.formattedValue + ' %';
            } else {
              return tooltipItem.dataset.note.length > 0 ? tooltipItem.dataset.note[tooltipItem.dataIndex] : null
            }
          },
        },
      },
    },
  };
};

export const useProcessPlugin = () => {
  return {
    id: 'processBar',
    beforeDatasetsDraw: function (chart, args, pluginOptions) {
      const { ctx, data, scales: { x, y },
        chartArea: { top, bottom, left, right, width, height } } = chart;
      ctx.save();
      const barHeight = height / y.ticks.length * data.datasets[0].barPercentage * data.datasets[0].categoryPercentage;
      const foundNull = data.datasets[0].data.find((element) => element === null);
      const full = (foundNull === undefined) ? true : false;

      data.datasets[0].data.forEach((datapoint, index) => {
        if (datapoint !== null) {
          ctx.beginPath();
          ctx.strokeStyle = data.datasets[0].borderColor;
          ctx.fillStyle = data.datasets[0].borderColor;
          ctx.lineWidth = barHeight * 0.8;
          ctx.lineJoin = 'round';
          if (full) {
            ctx.roundRect(left, y.getPixelForValue(index) - (barHeight / 2), width, barHeight, [5, 5, 5, 5]);
          } else {
            const nullCount = data.labels.filter(item => item === null).length;
            if (nullCount === 3) {
              ctx.roundRect(left, y.getPixelForValue(index) - (barHeight / 2) + 10, width, barHeight * 0.4, [5, 5, 5, 5]);
            } else if (nullCount === 2) {
              ctx.roundRect(left, y.getPixelForValue(index) - (barHeight / 2) + 4, width, barHeight * 0.6, [5, 5, 5, 5]);
            } else {
              ctx.roundRect(left, y.getPixelForValue(index) - (barHeight / 2) + 2, width, barHeight * 0.8, [5, 5, 5, 5]);
            }
          }
          ctx.fill();
        }
      });
    },
    afterDatasetsDraw: function (chart, args, pluginOptions) {
      const { ctx, data, scales: { x, y },
        chartArea: { top, bottom, left, right, width, height } } = chart;
      ctx.save();
      data.datasets[0].data.forEach((datapoint, index) => {
        if (data.datasets[0].unit === 'server') {
          return;
        } else {
          if (datapoint !== null) {
            ctx.font = '12px Inter';
            ctx.fillStyle = '#ffffff';
            ctx.fillText(`${datapoint} %`, left + 6, y.getPixelForValue(index) + 4)
          }
        }
      });

    },
  };
};

